export { EmailComponent } from '../workflow-email/email.component';
export { EmailFormComponent } from '../workflow-email/email-form.component';
export type { EmailUser } from '../workflow-email/email-user';
export type { WorkflowEmail } from '../workflow-email/workflow-email';
export { WorkflowEmailService } from '../workflow-email/workflow-email.service';
